const NAME = 'mazda';

export const isMazda = (token) => {
  const domain = window.location.host;

  return domain.includes(NAME) || token === NAME;
};
